<template>
  <div>
    <FormulateInput
      type="text"
      name="cep"
      v-model="cep"
      validation="required"
      label="CEP"
      v-mask="'#####-###'"
      @change="getAddress(cep)"
    />
    <div class="row">
      <div class="col-md-8">
        <FormulateInput
          type="text"
          name="rua"
          v-model="rua"
          validation="required"
          label="Rua"
        />
      </div>
      <div class="col-md-4">
        <FormulateInput
          type="text"
          name="numero"
          v-model="numero"
          validation="required"
          label="Número"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <FormulateInput
          type="text"
          name="complemento"
          v-model="complemento"
          label="Complemento"
        />
      </div>
      <div class="col-md-6">
        <FormulateInput
          type="text"
          name="bairro"
          v-model="bairro"
          validation="required"
          label="Bairro"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <FormulateInput
          type="text"
          name="cidade"
          v-model="cidade"
          validation="required"
          label="Cidade"
        />
      </div>
      <div class="col-md-6">
        <FormulateInput
          type="text"
          name="estado"
          v-model="estado"
          validation="required"
          label="Estado"
        />
      </div>
    </div>
  </div>
</template>
<script>
import cep from "cep-promise";
export default {
  name: "FormEndereco",
  data() {
    return {
      cep: "",
      rua: "",
      numero: "",
      complemento: "",
      bairro: "",
      cidade: "",
      estado: "",
      loading: false,
    };
  },
  methods: {
    getAddress(n = 0) {
      if (n) {
        this.cep = n;
      }
      if (this.cep && this.cep.length >= 8) {
        this.loading = true;
        cep(this.cep)
          .then((response) => {
            this.loading = false;
            this.rua = response.street;
            this.bairro = response.neighborhood;
            this.cidade = response.city;
            this.estado = response.state;
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_mixins.scss";
.item-card {
  text-align: center;
  width: 100%;
  border-radius: 5px;
  background: #fff;
  padding: 25px 10px;
  justify-content: space-between;
  align-items: center;
  color: #6c757d;
  margin-right: 5px;
  .item-card-valor {
    font-weight: bold;
    font-size: 20px;
    text-transform: uppercase;
    color: #000;
  }
  .item-card-titulo {
    font-weight: 300;
    font-size: 14px;
    text-transform: uppercase;
    margin-bottom: 10px;
  }
}
.relatorio-card-link {
  @include transition-all();
}
hr {
  color: #e9ecef !important;
  border-color: #e9ecef !important;
  border-width: 2px;
}
</style>
